export const routes = [
  { name: 'Partners', path: 'partners' },
  { name: 'Rewards', path: 'home' },
  { name: 'Customers', path: 'customers' },
  { name: 'Tasks', path: 'tasks' },
]

export const RULES_PAGE_TABS = {
  grants: {
    title: 'Grants',
  },
  'all-rules': {
    title: 'Rules',
  },
  categories: {
    title: 'Categories',
  },
  group: {
    title: 'Groups',
  },
  'loan-transaction-review': {
    title: 'Loan Transaction Review',
  },
}

export const PARTNERS_PAGE_TABS = {
  'all-partners': {
    title: 'Partners',
  },
  'json-upload': {
    title: 'JSON Upload',
  },
}

export const CUSTOMERS_PAGE_TABS = {
  'all-customers': {
    title: 'Customers',
  },
}

export const TASKS_PAGE_TABS = {
  'script-runs': {
    title: 'Script Runs',
  },
}

// Pagination defaults
export const DEFAULT_PER_PAGE = 25
